import React from 'react';
import useCostumers from '../../Hooks/useCostumers';
import Costumer from './Customer';

const CostumersList=()=>
{
    const customers=useCostumers();
    const {Customers ,CustomersDouble,CustomersFourfold}=customers;
   
    if(Customers.length===0)
    {
        return <p style={{fontSize:"32px", textAlign:"center"}}>Tu lista está vacia</p>
    }
    else
    {
        return <div>
        {Customers.map(customer => <Costumer customer={customer}  doubles={CustomersDouble} fourfolds={CustomersFourfold}/>)}
        </div>
    } 
}

export default CostumersList
